import React, { useEffect, useState } from 'react';
import axios from 'axios';
import WINGraph from './WINGraph';
import { basePath } from '../../index';
import { decimaNumberFormat } from '../UtilityComponents/UtilityFunction';
import html2pdf from "html2pdf.js";



function WhyInvestNow(props) {
    const [responseData, setResponseData] = useState([]);
    const [gdpTableData, setGdpTableData] = useState([]);
    const [isDownloadPDF, setDownloadPDF] = useState(false);

    const apiCall =async (URL) => {
        let model = {
            "ProductType": "investment"
        }

        return await axios.post(`central/centralcall/callreqwithheader`, { URL, Req: model });
    }

    
        

    useEffect(() => {
        callBothApi();
    }, []);

    const callBothApi = async() => {
        try {

            const rcaData = await apiCall("WhyInvestNowRCA");
            setResponseData(rcaData.data);

            const gdpData =await apiCall("WhyInvestNowGDP");
            setGdpTableData(gdpData.data);

           

        } catch (error) {
            console.log({ error });
        }
    }


    const generatePDF = async() => {
        setDownloadPDF(true);
        let element = document.getElementById('whyInvestNow');
      

        let clonnedElement = element.cloneNode(true);
        const closeBtn = clonnedElement.querySelector('.clsBtn');
        const pdfBtn = clonnedElement.querySelector('.save_pdf');
        const chartBtn = clonnedElement.querySelector('.canvasjs-chart-toolbar');
        const gotItBtn = clonnedElement.querySelector('.FactorTC-btn');
        if (gotItBtn) gotItBtn.remove();
        if (chartBtn) chartBtn.remove();
        if (pdfBtn) pdfBtn.remove();
        if (closeBtn) closeBtn.remove();
       

        const winCon = clonnedElement.querySelector('#WINContentId');
        if (winCon) {
            winCon.style.overflowY="none";
            winCon.style.maxHeight = "none";
            winCon.style.overflowX = "none";
        }

        // Set styles to make sure all content is visible in the PDF
        clonnedElement.style.maxHeight = "none";
        clonnedElement.style.overflow = "auto";
        clonnedElement.style.height = "auto"; 

        // ✅ Handle Charts (Convert to Image)
        let chartCanvas = document.querySelector(".GraphArea canvas");
        if (chartCanvas) {
            let chartImage = chartCanvas.toDataURL("image/png"); // Convert to base64 image
            let img = document.createElement("img");
            img.src = chartImage;
            img.style.width = "60%"; // Adjust size
            img.style.display = "block";
            img.style.margin = "auto";

            // Append image to cloned content
            let graphArea = clonnedElement.querySelector(".GraphArea");
            if (graphArea) {
                graphArea.innerHTML = ""; // Remove existing canvas
                graphArea.appendChild(img); // Add image instead
            }
        }

        // Use a temporary container to render full content
        let tempContainer = document.createElement("div");
        tempContainer.appendChild(clonnedElement);
       // document.body.appendChild(tempContainer);

        let opt = {
            margin: 0.5,
            filename: (props.EnquiryNo || '').replace("/", "_") + "_WhyInvestNow" + '_Summary.pdf', //SMC/ENQ/23/1234_Quotation_Summary.pdf
            image: { type: 'jpeg', quality: 1 },
            html2canvas: { scale: 3, letterRendering: true, useCORS: true, dpi: 300, windowHeight: 1000 },
            jsPDF: { unit: 'in', format: 'a4', orientation: 'l', putOnlyUsedFonts: true },
            enableLinks: true,
            height: "1000px",
             pagebreak: { mode: 'avoid-all', before: '.part2break' }
        };
        try {
            await html2pdf().set(opt).from(clonnedElement).save();
            setDownloadPDF(false);
        } catch (err) {
            // Handle error
            console.error(err);
        }
    }



    return (
        <>
            {isDownloadPDF ? <div className="IsDownlodPDF"><span class="PDFloader"></span> <span class="PDFloaderText">Generating PDF</span></div> : ""}
            <div className="Compare InvestmentLoginPage WINow" id="whyInvestNow">
                <div className="CalculatorHead InvestNow">
                    <h2>Why should you invest sooner than later?</h2>
                    <button className="clsBtn" onClick={props.close}>
                        <img src={require("../../Investment/Cross.svg").default} alt="" />
                    </button>
                </div>
                <div className="WINContent" id="WINContentId">
                    <div className="save_pdf">
                        <button onClick={generatePDF} >
                            <img src={require("../../Investment/Images/Icon metro-file-pdf.png")} alt="" />
                            <span> Save as PDF</span>
                        </button>
                    </div>
                    <p className="RCA-Text">Investing sooner rather than later offers several advantages and benefits, making it a wise financial decision. Here are some compelling reasons why one should consider investing at an early age.</p>
                    <div className="INSTF-Returns">
                        <p className="RCA-Text">As India progresses toward becoming a developed economy, tax exemptions across different asset classes will gradually diminish.</p>
                            <div class="WINTime">
                                <div class="WINColumn x">
                                    <span className="WINYear">Apr 2018</span>
                                    <p className="YearText a">Long-Term Capital Gains (LTCG) introduced for equity mutual funds</p>
                                </div>
                                <div class="WINColumn y">
                                    <span className="WINYear">Apr 2021</span>
                                    <p className="YearText b">Long-Term Capital Gains (LTCG) applicable to ULIPs with premiums exceeding 2.5 Lakh</p>
                                </div>
                                <div class="WINColumn x">
                                    <span className="WINYear">Apr 2023</span>
                                    <p className="YearText a">Tax upon maturity applies to policies with premiums exceeding 5 Lakh</p>
                                </div>
                                <div class="WINColumn y">
                                    <span className="WINYear">Apr 2023</span>
                                    <p className="YearText b">Tax on maturity in the Debt Mutual Funds</p>
                                </div>
                            </div>
                        <p className="Green-Text">Invest Now & Secure Tax-Free Returns!</p>
                    </div>
                    <div className="RCAContent">
                        <p className="RCA-Title">Rupee Cost Averaging (RCA)</p>
                        <p className="RCA-Text">The key idea behind RCA is that when the market is down, your fixed investment buys more units, effectively lowering the average cost per unit. When the market is up, you buy fewer units, but the overall impact of market fluctuations is reduced over time.</p>
                        <p className="RCA-Text">Let's understand with an example. Suppose you decide to invest in a mutual fund through a Rupee Cost Averaging approach. You contribute a fixed amount of money, let's say ₹1,000, on a monthly basis, regardless of whether the market is up or down.</p>
                        <div className="RCA-Table">
                            <div className="table-responsive tablesec">
                                <table className="RCAContentTable table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>Month</th>
                                            <th>Amount</th>
                                            <th>NAV</th>
                                            <th>Units</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {responseData?.map(row=>(
                                            <tr>
                                                <td>{row.Month}</td>
                                                <td>₹{ row.Amount}</td>
                                                <td>₹{decimaNumberFormat(row.NumberOfUnitNAV)}</td>
                                                <td>{Math.round(row.PriceOfUnits)}</td>
                                            </tr>))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <p className="Green-Text">Your per-unit average cost stands at ₹{decimaNumberFormat(responseData?.find(r => r.Month.toLowerCase() === 'total')?.NumberOfUnitNAV)}, making it clear that the right time to invest is now. For SIP investors, market timing is not a concern.</p>
                    </div>
                    <div className="RCAContent long-term-returns">
                        <p className="RCA-Title">Interest Rates vs. GDP (in Trillion $) Among Leading Nations</p>
                        <p className="RCA-Text">Interest rates have been steadily declining on a global scale, and India has also followed this trend, resulting in reduced bank FD rates in recent years. If rates continue to decrease, FD rates are expected to remain low over the next 5 to 10 years.</p>
                        <div className="RCA-Table">
                            <div className="table-responsive tablesec">
                                <table className="long-term-returns table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>Country</th>
                                            <th>GDP (in Trillions $)</th>
                                            <th>Interest Rate</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {gdpTableData?.map((item)=>(<tr>
                                            <td>{item.Country}</td>
                                            <td>${decimaNumberFormat(item.GDP?.split('$')[1])}</td>
                                            <td>{item.Intersterate}</td>
                                        </tr>))}
                                        
                                        
                                        
                                      
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <p className="Green-Text">Consider investing in guaranteed plans now to secure long-term returns.</p>
                    </div>
                    <div className="RCAContent">
                        <p className="RCA-Title">Public Provident Fund (PPF) Interest Rate History for last 10 years</p>
                        <div className="GraphArea">
                            <WINGraph />
                        </div>
                        <p className="RCA-Text">Small savings schemes do not provide a consistent fixed rate of return, as these rates may undergo multiple changes within a single year.</p>
                        <p className="RCA-Text"> In contrast, guaranteed plans offer you the opportunity to secure a fixed rate of return for up to 45 years.</p>
                    </div>
                    {/*<div className="FactorTC-btn">
                        <button className="FC-btn" onClick={props.close}><span className="FC-btn-text">Got It</span></button>
                    </div>*/}
                </div>
            </div>
        </>
    );
};

export default WhyInvestNow;
